<template>
  <div class="pagoda-async-select-wrap" :class="{loading}">
    <el-select
      :value="value"
      :placeholder="placeholderText"
      :class="{
        'is-focus': isFocus
      }"
      :value-key="valueKey"
      @visible-change="isFocus = arguments[0]"
      @input="handleInput"
      v-bind="$attrs"
      v-on="$$listeners"
      :disabled="loading || disabled"
      :loading="remote"
      ref="elSelect"
    >
      <el-select-all-option v-if="selectAllOption"></el-select-all-option>
      <template v-if="group">
        <el-option-group
          v-for="group in options"
          :key="group.label"
          :label="group.label"
        >
          <el-option
            v-for="option in group.options"
            :key="getOptionKey(option)"
            :label="getOptionLabel(option)"
            :value="getOptionValue(option)"
            :disabled="option.disabled"
          >
            <slot v-bind="option"></slot>
          </el-option>
        </el-option-group>
      </template>
      <el-option
        v-else
        v-for="(option, idx) in options"
        :key="getOptionKey(option)"
        :label="getOptionLabel(option)"
        :value="getOptionValue(option)"
        :disabled="option.disabled"
      >
        <slot v-bind="option"></slot>
      </el-option>
    </el-select>
    <span class="el-input__suffix el-input__suffix-loading">
      <span class="el-input__suffix-inner">
        <i class="el-select__caret el-input__icon el-icon-loading"></i>
      </span>
    </span>
  </div>
</template>

<script>
  import {
    noop,
    getEmptyObject,
    isEmpty,
    isObject
  } from '../../utils'
  import $pagoda from '../../utils/global'
  import ElSelectAllOption from './el-select-all-option'

  // 解决多次调用组件 会多次请求接口的问题
  let requestCache = {}

  $pagoda.$on('async:clear-cache', function (requestKey) {
    delete requestCache[requestKey]
  })

  export default {
    name: 'AsyncSelect',
    inheritAttrs: false,
    components: {
      ElSelectAllOption
    },
    props: {
      value: null,
      request: {
        type: Function,
        default: noop
      },
      getOptions: {
        type: Function,
        default: noop
      },
      labelKey: {
        type: String,
        default: 'label'
      },
      valueKey: {
        type: String,
        default: 'value'
      },
      clearCacheBeforeDestroy: {
        type: Boolean,
        default: true
      },
      isObjectValue: Boolean,
      disabled: {
        type: Boolean,
        default: false
      },
      group: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      loadingMsg: {
        type: String,
        default: '选项加载中'
      },
      selectAllOption: Boolean,
      requestKey: [String, Number]
    },
    data () {
      this.$$listeners = {}
      for(const [name, handler] of Object.entries(this.$listeners)) {
        if(name !== 'input' && name !== 'before-input' && name !== 'beforeInput'){
          this.$$listeners[name] = handler
        }
      }

      return {
        options: [],
        isFocus: false,
        loading: true,
        remote: true
      }
    },
    created () {
      this.refresh()
    },
    beforeDestroy () {
      if (this.clearCacheBeforeDestroy) {
        requestCache = {}
      }
    },
    methods: {
      handleInput (newVal, selectedData) {
        const input = () => this.$emit('input', newVal, selectedData)

        // 如果有监听before-input事件 则做拦截等待resolve
        if (this._events['before-input'] || this._events['beforeInput']) {
          this.$emit('before-input', input, newVal, selectedData)
          this.$emit('beforeInput', input, newVal, selectedData)
        } else {
          input()
        }
      },
      focus () {
        this.$refs.elSelect.focus()
      },
      getOptionKey (option) {
        return option[this.valueKey]
      },
      getOptionLabel (option) {
        return option[this.labelKey]
      },
      getOptionValue (option) {
        return this.isObjectValue ? option : (this.valueKey in option ? option[this.valueKey] : option[this.labelKey])
      },
      async refresh (force) {
        const {
          requestKey
        } = this
        this.remote = true

        let requestPromise

        if(requestKey && !force){
          if(requestCache[requestKey]){
            requestPromise = requestCache[requestKey]

            this.$emit('load-cache', requestCache[requestKey])
          } else {
            requestPromise = requestCache[requestKey] = this.request()
          }
        }else{
          requestPromise = requestCache[requestKey] = this.request()
        }

        const resultData = await requestPromise
        const options = this.getOptions !== noop ? this.getOptions(resultData) : resultData

        this.loading = false
        this.remote = false
        this.options = options

        this.$emit('complete')
        return requestPromise
      }
    },
    computed: {
      placeholderText () {
        if(this.loading){
          return this.loadingMsg
        }else if(isEmpty(this.value)){
          return this.placeholder
        }else{
          return ''
        }
      }
    },
    watch: {
      requestKey () {
        this.refresh()
      }
    }
  }
</script>
